import React from "react";
import Divider from "@material-ui/core/Divider";

const PageBreak = () => {
    return(
        <div style={{width: '100%'}}>
            <Divider style={{background: 'rgba(0, 0, 0, 0.05)'}}/>
            <Divider style={{background: 'rgba(0, 0, 0, 0.15)'}}/>
        </div>
    )
}
export default PageBreak;